import VipTag from "@/components/VipTag";
import { isBigCompanyByUser, VIP_RIGHT_IDENTIFICATION } from "@/constants/vip";
import useAppStore from "@/context/store";
import { goGdMerge } from "@/pageComponents/GdMerge";
import { getCurrentVip, getUserRightCount } from "@/services";
import getTimeDuration from "@/utils/getTimeDuration";
import useRequest from "@/utils/useReq";
import { Skeleton } from "antd";
import classNames from "classnames";
import dayjs from "dayjs";
import Link from "next/link";
import { useMemo } from "react";
import { Case, Default, Else, If, Switch, Then } from "react-if";
import { useVipCardRedTip } from "../redTipState";
import styles from "./index.module.less";

export function HBVipCard() {
  const { couponTip, orderTip, onCouponClick, onOrderClick } =
    useVipCardRedTip();

  const { user } = useAppStore(({ user, unPayOrders }) => ({
    user,
    unPayOrders,
  }));

  const { data } = useRequest(
    async () => {
      const { vips: effect_vips, material_vip_expire_at } =
        await getCurrentVip();

      if (effect_vips.length) {
        const download = await getUserRightCount([
          { right_code: VIP_RIGHT_IDENTIFICATION },
        ]);

        return {
          isVip: true,
          almostExipired:
            dayjs(material_vip_expire_at).diff(dayjs(), "day", true) < 3,
          expireTime: getTimeDuration({
            time: material_vip_expire_at,
            afterText: "",
            reverse: true,
          }),
          download: download[0],
        };
      }

      return {
        isVip: false,
      };
    },
    {
      cacheKey: "huaban-current-vip",
    }
  );

  const { isVip, expireTime, almostExipired, download } = data || {
    isVip: user?.extra?.material_vip > 0,
  };

  const isBigCompany = useMemo(() => {
    if (user) {
      return isBigCompanyByUser(user);
    }
  }, [user]);

  // 曾经是会员
  const isVipEver = useMemo(() => {
    return user.extra?.material_vip;
  }, [user]);

  return (
    <div className={classNames(styles.card, { [styles.isVip]: isVip })}>
      {!data ? (
        <Skeleton
          active
          className={styles.skeleton}
          title={{ width: 130 }}
          paragraph={{ rows: 1, className: styles.paragraph }}
        />
      ) : (
        <div className={styles.container}>
          <div className={styles.content}>
            <div className={styles.title}>
              <span>花瓣素材会员</span>
              <VipTag className={styles.vipTag} />
            </div>
            <Switch>
              <Case condition={almostExipired}>
                <div className={styles.subtitle}>
                  VIP将在<span>{expireTime}</span>后到期
                </div>
              </Case>
              <Case condition={isVip}>
                <If condition={isBigCompany}>
                  <Then>
                    <div className={styles.subtitle}>
                      可下载 <span>{download?.left || 0}</span>/
                      {download?.quantity || 0}
                    </div>
                  </Then>
                  <Else>
                    <div className={styles.subtitle}>
                      今日可下载 <span>{download?.left || 0}</span>/
                      {download?.quantity || 0}
                    </div>
                  </Else>
                </If>
              </Case>
              <Case condition={isVipEver}>
                <div className={styles.subtitle}>已过期</div>
              </Case>
              <Default>
                <div className={styles.subtitle}>开通会员，下载商用源文件</div>
              </Default>
            </Switch>
          </div>
          <Switch>
            <Case condition={!isVip}>
              <Link href={isVipEver ? "/me/right" : "/vip/info"} passHref>
                <a
                  className={styles.btn}
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    goGdMerge({
                      redirectUri: "/vip/info",
                    });
                  }}
                >
                  <div
                    className={styles.text}
                    data-gd-click="button_click"
                    data-button-name={isVipEver ? "会员中心" : "立即开通"}
                  >
                    {isVipEver ? "续费" : "立即开通"}
                  </div>
                </a>
              </Link>
            </Case>
            <Default>
              <Link href="/me/right">
                <a className={styles.btn}>
                  <div
                    className={styles.text}
                    data-gd-click="button_click"
                    data-button-name="会员中心"
                  >
                    会员中心
                  </div>
                </a>
              </Link>
            </Default>
          </Switch>
        </div>
      )}

      <div className={styles.vipBottom}>
        <Link href={"/me/download"}>
          <a data-gd-click="button_click" data-button-name="下载记录">
            <div>下载记录</div>
          </a>
        </Link>
        <Link href={"/me/coupon"}>
          <a
            onClick={onCouponClick}
            data-gd-click="button_click"
            data-button-name="优惠券"
          >
            <div>优惠券</div>
            {couponTip && <span className={styles.redTip}></span>}
          </a>
        </Link>
        <Link href={"/me/order"}>
          <a
            onClick={onOrderClick}
            data-gd-click="button_click"
            data-button-name="订单发票"
          >
            <div>订单发票</div>
            {orderTip && <span className={styles.redTip}></span>}
          </a>
        </Link>
      </div>
    </div>
  );
}
